<template>
  <div>
    <div class="row  mt-3 mb-2">
      <div class="col-sm-12">
        <div class="float-sm-end d-flex" style="justify-content: end">
          <div class="me-2">
              <button type="button" class="btn btn-success btn-rounded mb-2 mr-2" @click="newStatusPend()">
                <i class="mdi mdi-plus mr-1"></i> Novo
              </button>
            </div>
        </div>
      </div>
      <!-- end col-->
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="table-responsive">
          <table class="table table-centered table-hover">
            <thead>
              <tr>
                <th width="10%">Código</th>
                <th width="60%">Nome</th>
                <th width="20%">Status</th>
                <th>#</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="list in statusPends" :key="list.id">
                <td @click="editStatusPend(list.id)" class="link">
                  {{ list.id }}
                </td>
                <td @click="editStatusPend(list.id)" class="link">
                  {{ list.name }}
                </td>
                <td>
                  <b-dropdown
                    size="sm"
                    style="min-width:100px"
                    :variant="(parseInt(list.status)) === 1 ? 'success' : 'danger'"
                  >
                    <template v-slot:button-content >
                      {{ parseInt(list.status) === 1 ? 'Ativo' : 'Inativo' }}
                      <i class="mdi mdi-chevron-down"></i>
                    </template>
                    <span>
                      <b-dropdown-item-button @click="toggleStatus(list.id)" v-if="parseInt(list.status) !== 1">Ativar</b-dropdown-item-button>
                      <b-dropdown-item-button @click="toggleStatus(list.id)" v-if="parseInt(list.status) !== 0">Inativar</b-dropdown-item-button>
                    </span>
                  </b-dropdown>
                </td>
                <td>
                  <button v-if="user.role === 'Admin'" type="button" @click="deleteStatusPend(list)" class="link btn btn-outline-danger btn-sm"><i class="bx bx-trash"></i></button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row">
          <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-right">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" @input="updateList"></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal-form v-model="modalForm" ref="formStatus" @created="updateList"></modal-form>
  </div>
</template>
<script>
import Swal from 'sweetalert2'
import { mapActions, mapState } from 'vuex'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import ModalForm from './Form'

export default {
  components: {
    ModalForm
  },
  props: {
    idTemplate: {
      type: Number || String,
      default: null
    }
  },
  data () {
    return {
      loading: true,
      fullPage: true,
      submitted: false,
      modalForm: false,
      params: {},
      totalRows: 1,
      currentPage: 1,
      perPage: 5
    }
  },
  mounted () {
    this.updateList()
    this.totalRows = this.pagination.total
    this.currentPage = this.pagination.current_page
  },
  methods: {
    ...mapActions('statusPends', {
      getAll: 'getAll',
      delete: 'deleteStatusPend',
      changeStatus: 'changeStatus'
    }),
    editStatusPend (id) {
      this.$refs.formStatus.open(id)
      this.modalForm = true
    },
    newStatusPend () {
      this.$refs.formStatus.open('')
      this.modalForm = true
    },
    async toggleStatus (id) {
      try {
        await this.changeStatus(id)
        let message = 'Sucesso: Status atualizado com sucesso.'
        let delay = 2500
        successMessage(message, delay)
        this.updateList()
      } catch (err) {
        errorMessage('Alerta: ' + err.message)
      }
    },
    async deleteStatusPend (status) {
      Swal.fire({
        title: 'Você tem certeza ?',
        html: `Será excluido o tipo de anexo: <br /><b>${status.name}</b>`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#f46a6a',
        cancelButtonColor: '#4a4848',
        cancelButtonText: 'CANCELAR',
        confirmButtonText: 'SIM, DESEJO EXCLUIR!'
      }).then(async (result) => {
        if (result.isConfirmed) { // Alterado de result.value para result.isConfirmed (mais claro no Swal)
          try {
            await this.delete(status.id) // Aguarda a conclusão da requisição
            successMessage('Sucesso: Tipo de anexo excluído com sucesso.', 2500)
            this.updateList()
          } catch (err) {
            if (err.message) {
              const message = err.message || 'Erro desconhecido ao excluir o tipo de anexo.'
              errorMessage(`Alerta: ${message}`)
            } else {
              errorMessage('Alerta: Falha na conexão com o servidor.')
            }
          }
        }
      })
    },
    getReport (filter) {
      let params = {
        include: 'template',
        search: this.search || null,
        limit: this.perPage,
        page: this.currentPage
      }
      this.params = params
      let loeader = this.$loading.show()
      this.getAll(this.params).then((res) => {
        // this.participants = res.data
        this.totalRows = this.pagination.total
        this.currentPage = this.pagination.current_page
        loeader.hide()
      }).catch(error => {
        console.log(error)
        loeader.hide()
      })
    },
    updateList () {
      this.getReport(this.params)
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('statusPends', ['statusPends', 'pagination']),
    rows () {
      return this.pagination.total
    }
  },
  watch: {
    modal () {
      if (!this.modal) {
        this.close()
      }
    }
  }
}
</script>
<style scoped>
.vld-overlay.is-full-page {
    z-index: 1051 !important;
}
</style>
